<template>
    <WidgetTitle 
        :styles="content.styles"
        :translation="content.translation"
        :upload="content.upload"
    >
        <div class="d-flex flex-wrap justify-content-center mt-6">
            <HomeTeamMember
                v-for="member in team_members"
                :key="member.id"
                :member="member"
                :color="content.styles.color"
            />    
        </div>
    </WidgetTitle>
</template>

<script>

import WidgetTitle from '../Common/WidgetTitle'
import HomeTeamMember from './HomeTeamMember'

export default {
    name: 'HomeTeam',
    components: {
        WidgetTitle,
        HomeTeamMember
    },
    props: {
        content: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            team_members: this.content.contents
        }
    }
}
</script>

<style>

</style>